import { Avatar, Checkbox, Space } from 'antd'
import { useEffect, useState } from 'react'
import plusBlue from 'assets/Images/plusBlue.svg'
import {
  useDeleteItemsToBring,
  useGetItemsToBring,
} from 'api/Listings/itemsToBring'
import Spinner from 'components/Spinner'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'
import { itemsToBringStore } from 'state/listing/itemsToBringListing'
import ItemsToBringModal from 'pages/Settings/Listings/Modals/ItemsToBringModal'
import { ItemsToBringListing } from 'types/listing/listings'
import { PencilSimple, Trash } from '@phosphor-icons/react'
import AlertModal from 'helper/AlertModal'

const ItemsToBring = ({
  closeMdoal,
  prevItems,
  setPrevItems,
  organizationId,
}) => {
  const [alertModal, setAlertModal] = useState<boolean>(false)
  const [selectedItem, setSelectedItem] = useState<
    ItemsToBringListing | undefined
  >()
  const { addItemToBringModal, setAddItemsToBringModal, setItemToBringData } =
    itemsToBringStore(store => ({
      addItemToBringModal: store.addItemsToBringModal,
      setAddItemsToBringModal: store.setAddItemsToBringModal,
      setItemToBringData: store.setItemsToBringData,
    }))
  const {
    isLoading: itemsLoading,
    isFetching: itemsFetching,
    data: itemsData,
    refetch: itemsDataRefetch,
  } = useGetItemsToBring({ organizationId: organizationId })
  const { mutate: deleteItemToBringMutation, isLoading: deleteItemLoading } =
    useDeleteItemsToBring()

  const handleSave = () => {
    closeMdoal(false)
  }
  const handleAddItem = () => {
    setItemToBringData(null)
    setAddItemsToBringModal(true)
  }

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setPrevItems(checkedValues)
  }

  const handleEditClick = (item: ItemsToBringListing) => {
    setItemToBringData(item)
    setAddItemsToBringModal(true)
  }

  const handleDeleteClick = (item: ItemsToBringListing) => {
    setSelectedItem(item)
    setAlertModal(true)
  }

  const handleYesDelete = () => {
    deleteItemToBringMutation(selectedItem._id, {
      onSuccess: () => {
        setSelectedItem(null)
        setAlertModal(false)
      },
    })
  }

  useEffect(() => {
    itemsDataRefetch()
  }, [organizationId])

  return (
    <>
      <div className="">
        <p>
          Listed below what is mandatory things should kid bring with themselves
          for the event
        </p>
        {itemsLoading || itemsFetching ? (
          <div className="py-40px flex justify-center">
            <Spinner />
          </div>
        ) : itemsData.length > 0 ? (
          <div className="mt-20px">
            <Checkbox.Group
              value={prevItems}
              onChange={onChange}
              className="d-flex flex flex-column flex-wrap gap-10"
            >
              {itemsData.map((item: ItemsToBringListing) => {
                return (
                  <div
                    key={item._id}
                    className="flex justify-between align-center gap-10px"
                  >
                    <Checkbox
                      value={item._id}
                      className="items-listing checkbox mt-10px mb-10px"
                    >
                      <Space size={12}>
                        <Avatar
                          size={40}
                          src={item.icon.thumb}
                          className="ml-5"
                        ></Avatar>
                        <h4 className="b3">{item.name}</h4>
                      </Space>
                    </Checkbox>

                    {item.organizationId && (
                      <div className="flex items-center justify-between gap-16px">
                        {item.organizationId && (
                          <PencilSimple
                            size={20}
                            color="#000"
                            className="pointer"
                            onClick={() => handleEditClick(item)}
                          />
                        )}
                        <Trash
                          size={20}
                          color="#ff6961"
                          className="pointer"
                          onClick={() => handleDeleteClick(item)}
                        />
                      </div>
                    )}
                  </div>
                )
              })}
            </Checkbox.Group>
          </div>
        ) : (
          <div className="py-40px flex justify-center">
            <p>No items are added</p>
          </div>
        )}
        <div className="mt-30px flex gap-20px justify-between align-center">
          <button
            className="pointer flex align-center gap-16px simple-btn"
            onClick={handleAddItem}
          >
            <img src={plusBlue}></img> <p>Add new Item</p>
          </button>
          <button className="confirm-btn pointer" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
      {addItemToBringModal && (
        <ItemsToBringModal organizationId={organizationId} />
      )}
      {alertModal && (
        <AlertModal
          isModalVisible={alertModal}
          setIsModalVisible={setAlertModal}
          data={{
            name: 'Item to bring',
            heading: `Delete ${selectedItem?.name}`,
            message1: 'Are you sure you want to delete this team?',
            okText: 'Yes',
          }}
          onYesClick={handleYesDelete}
          loading={deleteItemLoading}
        />
      )}
    </>
  )
}

export default ItemsToBring
